export const GATEWAY_API_URL = import.meta.env['VITE_GATEWAY_API_URL'];
export const STYLIST_API_URL = import.meta.env['VITE_STYLIST_API_URL'];
export const CRM_ADMIN_API_URL = import.meta.env['VITE_CRM_ADMIN_API_URL'];
export const PORTAL_NAME = import.meta.env['VITE_PORTAL_NAME'] as
  | 'admin'
  | 'vendor'
  | 'warehouse'
  | 'synq'
  | 'logistics';
export const UNICOMMERCE_PORTAL_URL = import.meta.env['VITE_UNICOM_URL'];
export const APP_ENV = import.meta.env['VITE_APP_ENV'];
export const SHOULD_HIDE_CUSTOMER_PHONE = PORTAL_NAME === 'vendor';

const parseOptionalNumber = (value: string | undefined) => {
  if (!value?.trim()) {
    return undefined;
  }

  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

export const MTO_HOMEPAGE_ONE_VIEW_CARD_ID = parseOptionalNumber(
  import.meta.env['VITE_MTO_HOMEPAGE_ONE_VIEW_CARD_ID'],
);

export const getAppName = () => {
  switch (PORTAL_NAME) {
    case 'admin': {
      return 'Foundation';
    }
    case 'logistics': {
      return 'Logistics';
    }
    case 'synq': {
      return 'Synq';
    }
    case 'vendor': {
      return 'Nexus';
    }
    case 'warehouse': {
      return 'Hub';
    }

    default: {
      return 'Foundation';
    }
  }
};
